import { Injectable } from '@angular/core';
import { PrestationTypeModel } from '../../../../core/models/prestation-type.model';
import { HttpClient } from '@angular/common/http';
import { BaseService } from '../../../../core/base/base.service';
import { ProductCategoryModel } from '../../../../core/models/product-category.model';
import { Observable } from 'rxjs';
import { ObjectApiInterface } from '../../../../core/base/interfaces/object-api.interface';
import { AuthService } from '../../../../core/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class ProductCategoryService extends BaseService<ProductCategoryModel> {
  defaultSort = 'createdAt';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {
    super(http, 'product-category', authService);
  }

  checkDependencies(category: ProductCategoryModel) {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/checkDependencies/${category._id}`, {});
  }

  changeAndArchiveGeneric(_id: string, body: any) {
    return this.http.post<ObjectApiInterface<any>>(`${this.baseUrlApi}/changeAndArchiveGeneric/${_id}`, body);
  }

  downloadExcelTemplateWithFilter(filter: 'with' | 'without'): Observable<ObjectApiInterface<any>> {
    return this.http.get<ObjectApiInterface<any>>(
      `${this.baseUrlApi}/download-excel-template-with-data?filter=${filter}`,
    );
  }
}
